import { render } from "./CartAdd.vue?vue&type=template&id=cbbe0c0c"
import script from "./CartAdd.vue?vue&type=script&lang=js"
export * from "./CartAdd.vue?vue&type=script&lang=js"

import exportComponent from "/builds/rclass/new_shlepakov/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__